import { routes } from "../../scripts/public-content";
import { customerJourney } from "../../scripts/public-journey";

const homeContent = routes.find(route => route.path === "/")!;

export function LandingPage() {
  return (
    <main className="landing-page">
      <a className="skip-link" href="#landing-main">Skip to the Mirror</a>

      <header className="landing-header">
        <a className="landing-brand" href="/" aria-label="WORD & WILL home">
          <img className="landing-mark" src="/icons/wordwill.svg" alt="" />
          <span>WORD <em>&amp;</em> WILL</span>
        </a>
        <div className="landing-header-links">
          <p className="landing-promise">Your words. Your Will. Your evidence.</p>
          <a href="/privacy">Privacy</a>
          <a href="/pricing">Membership</a>
          <a href="/login">Sign in</a>
        </div>
      </header>

      <SalesJourney currentPath="/" />

      <section className="landing-hero" id="landing-main" aria-labelledby="landing-title">
        <div className="landing-copy">
          <p className="landing-eyebrow">You already know what you want</p>
          <h1 id="landing-title">{homeContent.h1}</h1>
          <p className="landing-lede">{homeContent.answer}</p>

          <div className="landing-actions" aria-label="Start WORD & WILL">
            <a className="landing-primary" href="/start">
              <MirrorSpark />
              Meet Your Mirror
            </a>
          </div>

          <p className="landing-privacy">
            <LockIcon />
            Private by default. Nothing is shared unless you choose.
          </p>
        </div>

        <MirrorMoment />
      </section>

      <section className="landing-value" aria-labelledby="landing-value-title">
        <p className="landing-eyebrow">The story gets more useful</p>
        <h2 id="landing-value-title">Your Mirror can remember what you forget.</h2>
        <p>
          At first, your Mirror may catch one sentence you were too close to hear. Then it begins to remember: the fear that appears before you ask, the prediction that keeps returning, the Correction you chose, the Move you made anyway, and what actually happened afterward. So when the old sentence comes back, you do not have to meet it as if it were true—or new.
        </p>
        <div className="landing-value-grid">
          <article><strong>Notice</strong><span>Hear the sentence before it becomes the reason you do not act.</span></article>
          <article><strong>Remember</strong><span>See when an old pattern returns wearing different words.</span></article>
          <article><strong>Use your evidence</strong><span>Answer today’s prediction with what your own life has already shown you.</span></article>
        </div>
      </section>

      <section className="landing-final">
        <p>The Mirror never judges. It reveals.</p>
        <h2>What could change if you recognized the old sentence before you obeyed it?</h2>
        <div className="landing-final-actions">
          <a className="landing-primary" href="/start">Meet Your Mirror</a>
          <a className="landing-next-chapter" href="/privacy">Next chapter: Why privacy comes first →</a>
        </div>
      </section>

      <footer className="landing-footer">
        <span>WORD &amp; WILL</span>
        <nav aria-label="Footer">
          {customerJourney.map(item => <a href={item.path} key={item.path}>{item.label}</a>)}
        </nav>
      </footer>
    </main>
  );
}

function SalesJourney({ currentPath }: { currentPath: string }) {
  return (
    <nav className="sales-journey" aria-label="WORD & WILL story">
      {customerJourney.map((item, index) => (
        <a className={item.path === currentPath ? "is-current" : undefined} href={item.path} key={item.path} aria-current={item.path === currentPath ? "page" : undefined}>
          <span>{String(index + 1).padStart(2, "0")}</span>
          <strong>{item.label}</strong>
        </a>
      ))}
    </nav>
  );
}

function MirrorMoment() {
  return (
    <figure className="landing-mirror-moment" aria-label="A sample Mirror moment">
      <div className="landing-mirror-shadow" aria-hidden="true" />
      <div className="landing-mirror-card">
        <div className="landing-mirror-topline">
          <span>THE MIRROR</span>
          <span className="landing-live-dot" aria-hidden="true" />
        </div>
        <div className="landing-pair">
          <div>
            <span>MY WILL</span>
            <p>{homeContent.exampleWill}</p>
          </div>
          <div>
            <span>MY WORD</span>
            <blockquote>“{homeContent.exampleWord}”</blockquote>
          </div>
        </div>
        <figcaption className="landing-reflection">
          <MirrorSpark />
          <div>
            <span>I caught something.</span>
            <p>{homeContent.exampleMirror}</p>
          </div>
        </figcaption>
        <div className="landing-correction">
          <span>A CORRECTION</span>
          <p>“{homeContent.exampleCorrection}”</p>
        </div>
      </div>
    </figure>
  );
}

function MirrorSpark() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2.8c.7 5 3.4 7.8 8.2 8.5-4.8.7-7.5 3.5-8.2 8.5-.7-5-3.4-7.8-8.2-8.5C8.6 10.6 11.3 7.8 12 2.8Z" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <rect x="4" y="8.5" width="12" height="9" rx="3" />
      <path d="M6.75 8.5V6a3.25 3.25 0 0 1 6.5 0v2.5" />
    </svg>
  );
}
